export default __webpack_public_path__ + "static/media/aws.7abb631e.jpg";